// core version + navigation, pagination modules:
import Swiper, { FreeMode, Scrollbar } from "swiper";

function eventsSlider() {

    const swiper = new Swiper(".events-slider", {
      modules: [FreeMode, Scrollbar],
      loop: false,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      slidesPerColumn: 1,
      spaceBetween: 15,
      speed: 1000,
      freeMode: {
        enabled: true,
        sticky: false,
        momentum: true,
        momentumRatio: 0.6,
        momentumVelocityRatio: 0.6,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
      breakpoints: {
        640: {
          spaceBetween: 30,
        },
        1024:  {
          spaceBetween: 50,
        },
      },
    });
  
}
eventsSlider();
window.addEventListener("resize", eventsSlider);

export default eventsSlider;
